/**
 * @generated SignedSource<<14e19c14df093223e6be0fcd35cada36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postiesSectionSecondaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink">;
  readonly " $fragmentType": "postiesSectionSecondaryContentItemContent";
};
export type postiesSectionSecondaryContentItemContent$key = {
  readonly " $data"?: postiesSectionSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"postiesSectionSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postiesSectionSecondaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "52bc305a3684544533ef6a75774b6234";

export default node;
